import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import SpinnerBlock from 'components/others/SpinnerBlock';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';
import ReportDate from '../ReportDate';
import { useReportUsers } from './model';
import ObjectStatusFilter from './ObjectStatusFilter';
import ReportUsersSummaryTable from './ReportUsersSummaryTable';
import ReportUsersDetail from './ReportUsersDetail';

const ReportUsers = () => {
    const { t } = useTranslation(['Reports']);
    const {
        users,
        isReporting,
        setDates,
        dateFilter,
        viewMode,
        objectFilter,
        handleDateFilterChange,
        handleViewModeToggle,
        handleObjectFilterChange,
    } = useReportUsers();

    const isDetail = viewMode === 'detail';

    return (
        <Row>
            <Col className="col-sticky" sm={12}>
                <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start gap-2">
                    <div className="flex-shrink-0">
                        <h4 className="p-0 m-0 mb-0 me-2 text-nowrap">
                            {t('common:SideBarUl.itemRepostsUsers')}
                        </h4>
                    </div>
                    <div className="mt-2 mt-sm-0 mb-2 page-toolbar-actions">
                        <div className="me-1">
                            <EToolTip
                                title={
                                    isDetail
                                        ? t('usersView.summaryHint')
                                        : t('usersView.detailHint')
                                }
                            >
                                <span className="d-inline-block">
                                    <Button
                                        className="fs-14 px-2 toolbar-icon-btn"
                                        size="sm"
                                        variant={isDetail ? 'info' : 'secondary'}
                                        disabled={isReporting}
                                        onClick={(e) => {
                                            e.currentTarget.blur();
                                            handleViewModeToggle();
                                        }}
                                    >
                                        <SolarIcon name="list-ul" className="fs-14 p-0" />
                                    </Button>
                                </span>
                            </EToolTip>
                        </div>
                        <ObjectStatusFilter
                            value={objectFilter}
                            onChange={handleObjectFilterChange}
                            disabled={isReporting}
                        />
                        <ReportDate
                            setDates={setDates}
                            disabled={isReporting}
                            initialFilter={dateFilter}
                            onFilterChange={handleDateFilterChange}
                        />
                    </div>
                </div>
            </Col>

            <Col sm={12}>
                <div className="px-0 position-relative">
                    {users == null ? (
                        <ESpinner />
                    ) : (
                        <>
                            <SpinnerBlock onlyBlur={true} show={isReporting} />
                            {isDetail ? (
                                <ReportUsersDetail users={users} />
                            ) : (
                                <ReportUsersSummaryTable users={users} />
                            )}
                        </>
                    )}
                </div>
            </Col>
        </Row>
    );
};

export default ReportUsers;
